/* FRALORA — קיבוץ ערכי פילטר (משפחות ריח)
   תיבה גלויה אחת לכל משפחה; התיבות המוסתרות של אותה משפחה מסתנכרנות איתה.
   רץ בשלב capture, לפני שהסינון של Minimog קורא את הטופס (אחרי 500ms). */
(function () {
  if (window.__frFilters) return;
  window.__frFilters = true;

  function sync(primary) {
    var form = primary.form || primary.closest('form');
    if (!form) return;
    var key = primary.getAttribute('data-fr-group-primary');
    form.querySelectorAll('[data-fr-group-member="' + key + '"]').forEach(function (member) {
      member.checked = primary.checked;
    });
  }

  ['input', 'change'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      var el = event.target;
      if (el && el.matches && el.matches('[data-fr-group-primary]')) sync(el);
    }, true);
  });

  // תגית פילטר פעיל של משפחה: מסירה את כל הערכים של המשפחה בבת אחת
  document.addEventListener('click', function (event) {
    var chip = event.target.closest && event.target.closest('[data-fr-group-chip]');
    if (!chip) return;
    var form = document.getElementById('CollectionFiltersForm');
    var primary = form && form.querySelector('[data-fr-group-primary="' + chip.getAttribute('data-fr-group-chip') + '"]');
    if (!primary) return; // בלי הטופס: הקישור הרגיל מסיר את כל הפילטר
    event.preventDefault();
    event.stopPropagation();
    primary.checked = false;
    sync(primary);
    form.dispatchEvent(new Event('input', { bubbles: true }));
  }, true);
})();
